<svg class="circle-progress" width="130" height="130" viewBox="0 0 130 130">
  <circle class="circle-progress-meter" cx="65" cy="65" r="54" stroke-width="7"></circle>
  <circle #progressValue class="circle-progress-value" cx="65" cy="65" r="54" stroke-width="15"></circle>
</svg>
